import Vue from 'vue'
import Router from 'vue-router'
// import Products from '@/components/Products'
import Home from '@/components/Home/Home'
import Feature from '@/components/Feature/Feature'
import Prices from '@/components/Prices/'
import Payment from '@/components/Prices/Payment'
import Confirm from '@/components/Prices/Confirm'
import Success from '@/components/Prices/Success'
import Resource from '@/components/Resources/Resources'
import Contact from '@/components/Contact/Contact'
import About from '@/components/About'
import Download from '@/components/Download'
import Serversupport from '@/components/Serversupport'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/Home',
    name: 'Home',
    component: Home
  }, {
    path: '/Home',
    name: 'Home2',
    component: Home
  }, {
    path: '/Feature',
    name: 'Feature',
    component: Feature
  }, {
    path: '/Prices',
    name: 'Prices',
    component: Prices
  }, {
    path: '/Prices/Payment',
    name: 'Payment',
    component: Payment
  }, {
    path: '/Prices/Confirm',
    name: 'Confirm',
    component: Confirm
  }, {
    path: '/Prices/Success',
    name: 'Success',
    component: Success
  }, {
    path: '/Resource',
    name: 'Resource',
    component: Resource
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact
  }, {
    path: '/about',
    name: 'about',
    component: About
  }, {
    path: '/download',
    name: 'download',
    component: Download
  }, {
    path: '/serversupport',
    name: 'serversupport',
    component: Serversupport
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js